"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _ProductsAndPlansNavIds = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HubTitle = _styledComponents.default.div.withConfig({
  displayName: "StandardProductPageTitle__HubTitle",
  componentId: "mpsxco-0"
})(["color:#33475b;font-size:", ";font-weight:600;text-align:center;margin:0 auto 10px;", ";display:flex;justify-content:center;align-items:center;min-height:44px;"], function (_ref) {
  var size = _ref.size;
  return size === 'small' ? '26px' : '32px';
}, _responsiveBreakpoints.default.tabletPortrait(_templateObject()));

var Trademark = _styledComponents.default.span.withConfig({
  displayName: "StandardProductPageTitle__Trademark",
  componentId: "mpsxco-1"
})(["font-weight:200;font-size:70%;"]);

var StandardProductPageTitle = function StandardProductPageTitle(_ref2) {
  var hub = _ref2.hub,
      size = _ref2.size,
      isNew = _ref2.isNew,
      includeTrademark = _ref2.includeTrademark,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["hub", "size", "isNew", "includeTrademark"]);
  return _react.default.createElement(HubTitle, Object.assign({
    size: size
  }, rest), _react.default.createElement(_UIImage.default, {
    className: "display-inline m-right-3",
    src: _ProductPageIcons.default[hub]
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.products.tabs." + hub + ".pageTitle"
  }), includeTrademark && _react.default.createElement(Trademark, null, "\u2122"), isNew && _react.default.createElement(_UIBadge.default, {
    use: "new",
    className: "m-left-3"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.new"
  })));
};

StandardProductPageTitle.propTypes = {
  hub: _propTypes.default.oneOf(Object.values(_ProductsAndPlansNavIds.default || {})).isRequired,
  size: _propTypes.default.oneOf(['default', 'small']),
  isNew: _propTypes.default.bool,
  includeTrademark: _propTypes.default.bool
};
StandardProductPageTitle.defaultProps = {
  size: 'default',
  isNew: false,
  includeTrademark: false
};
var _default = StandardProductPageTitle;
exports.default = _default;
module.exports = exports.default;